import type { components } from '@/api'

export type Weekday = components['schemas']['Weekday']

/** The chips, Sun to Sat as the prototype shows them (DP-25, feature owner 2026-10-21). */
export const WEEKDAYS: readonly { value: Weekday; short: string; name: string }[] = [
  { value: 'sunday', short: 'Sun', name: 'Sunday' },
  { value: 'monday', short: 'Mon', name: 'Monday' },
  { value: 'tuesday', short: 'Tue', name: 'Tuesday' },
  { value: 'wednesday', short: 'Wed', name: 'Wednesday' },
  { value: 'thursday', short: 'Thu', name: 'Thursday' },
  { value: 'friday', short: 'Fri', name: 'Friday' },
  { value: 'saturday', short: 'Sat', name: 'Saturday' },
]

// The contract lists days Monday first, and the page sends them in that order.
const CONTRACT_ORDER: readonly Weekday[] = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
]

/** Every day, as a new engine starts and as daily starts after hourly. */
export const ALL_DAYS: readonly Weekday[] = CONTRACT_ORDER

/** The chosen days in the contract's order, each once. */
export function mondayFirst(days: readonly Weekday[]): Weekday[] {
  return CONTRACT_ORDER.filter((day) => days.includes(day))
}

/** Short names in the order the chips show them: "Sun", "Mon". */
export function shortNames(days: readonly Weekday[]): string[] {
  return WEEKDAYS.filter((day) => days.includes(day.value)).map((day) => day.short)
}
